import type { ListType } from '@/models/app';

const QA_CALIBRATION_SOURCES = ['#ai-ride-tool-feedback', '#transportation-registrations'] as const;

export const QA_CALIBRATION_SOURCE_OPTIONS: ListType[] = QA_CALIBRATION_SOURCES.map((source, index) => ({
  id: index + 1,
  key: source,
  label: source,
}));

export const qaCalibrationRoles: string[] = ['admin', 'director', 'supervisor', 'supervisorTeamLead', 'gourmet-supervisor', 'teamLead', 'rideTeamLead', 'grocery-manager', 'lossPrevention', 'lossPreventionGourmet', 'lossPreventionGrocery', 'qualityAssurance'];
